import { Transaction } from "libs/transaction";

export class UndoRedoStack {
  undoStack: Transaction[] = [];
  redoStack: Transaction[] = [];
}
